import { render, staticRenderFns } from "./Cannes2025.vue?vue&type=template&id=f60b8c2e&scoped=true"
import script from "./Cannes2025.vue?vue&type=script&lang=js"
export * from "./Cannes2025.vue?vue&type=script&lang=js"
import style0 from "./Cannes2025.vue?vue&type=style&index=0&id=f60b8c2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60b8c2e",
  null
  
)

export default component.exports